import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { AccountSettingGroupShape } from './services';

export default function DisplaySettingGroup({
  item, toggleEdit, doDelete, tdStyle,
}) {
  return (
    <Fragment>
      <td style={tdStyle}>{ item.settingGroupKey}</td>
      <td style={tdStyle}>{ item.settingGroupValue}</td>
      <td style={tdStyle}>{ item.settingGroupAccessControl}</td>
      <td style={tdStyle}>
        {item.settingGroupKey !== '' && (
          <Fragment>
            <button type="button" className="badge badge-success badge-btn" onClick={() => toggleEdit(item)}>Edit</button>
            <span>&nbsp;&nbsp;</span>
            <button type="button" className="badge badge-danger badge-btn" onClick={event => doDelete(event, item)}>Delete</button>
          </Fragment>
        )}
      </td>
    </Fragment>
  );
}

DisplaySettingGroup.propTypes = {
  item: PropTypes.shape(AccountSettingGroupShape).isRequired,
  toggleEdit: PropTypes.func.isRequired,
  doDelete: PropTypes.func.isRequired,
  tdStyle: PropTypes.instanceOf(Object).isRequired,
};
